<template>
    <div>
        <h3 class="mb-3 text-right text-[13px] font-medium text-theme-text">
            {{ localizations[lang].margins }}
        </h3>
        <div class="flex gap-1.5">
            <!-- Minimum: solid border frame with text lines -->
            <SettingsButton
                variant="icon"
                :is-active="selectedValue === options[0].value"
                :aria-label="localizations[lang][options[0].labelKey]"
                @click="selectOption(options[0])"
            >
                <svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <line
                        x1="2"
                        y1="0"
                        x2="2"
                        y2="18"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-dasharray="2 2"
                    ></line>
                    <line
                        x1="22"
                        y1="0"
                        x2="22"
                        y2="18"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-dasharray="2 2"
                    ></line>
                    <rect x="4" y="3" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="8" width="16" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="4" y="13" width="16" height="2" rx="1" fill="currentColor"></rect>
                </svg>
            </SettingsButton>

            <!-- Normal: dotted vertical lines with medium content -->
            <SettingsButton
                variant="icon"
                :is-active="selectedValue === options[1].value"
                :aria-label="localizations[lang][options[1].labelKey]"
                @click="selectOption(options[1])"
            >
                <svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <line
                        x1="2"
                        y1="0"
                        x2="2"
                        y2="18"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-dasharray="2 2"
                    ></line>
                    <line
                        x1="22"
                        y1="0"
                        x2="22"
                        y2="18"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-dasharray="2 2"
                    ></line>
                    <rect x="6" y="3" width="12" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="6" y="8" width="12" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="6" y="13" width="12" height="2" rx="1" fill="currentColor"></rect>
                </svg>
            </SettingsButton>

            <!-- Maximum: dotted vertical lines closer, narrow content -->
            <SettingsButton
                variant="icon"
                :is-active="selectedValue === options[2].value"
                :aria-label="localizations[lang][options[2].labelKey]"
                @click="selectOption(options[2])"
            >
                <svg width="24" height="18" viewBox="0 0 24 18" fill="none">
                    <line
                        x1="2"
                        y1="0"
                        x2="2"
                        y2="18"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-dasharray="2 2"
                    ></line>
                    <line
                        x1="22"
                        y1="0"
                        x2="22"
                        y2="18"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-dasharray="2 2"
                    ></line>
                    <rect x="10" y="3" width="4" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="10" y="8" width="4" height="2" rx="1" fill="currentColor"></rect>
                    <rect x="10" y="13" width="4" height="2" rx="1" fill="currentColor"></rect>
                </svg>
            </SettingsButton>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import {
    MARGINS_DEFAULT,
    MARGINS_MAXIMUM,
    MARGINS_MINIMUM,
    MARGINS_NORMAL,
} from '../../../../src/js/components/partials/Epub/Readium/readium2-styles';
import SettingsButton from './SettingsButton.vue';

const MARGINS_OPTIONS = [
    { value: MARGINS_MINIMUM, labelKey: 'marginsMinimum' },
    { value: MARGINS_NORMAL, labelKey: 'marginsNormal' },
    { value: MARGINS_MAXIMUM, labelKey: 'marginsMaximum' },
];

export default {
    name: 'MarginsSelector',
    components: {
        SettingsButton,
    },
    computed: {
        ...mapState(['localizations', 'lang', 'userSettings']),

        options() {
            return MARGINS_OPTIONS;
        },

        selectedValue() {
            return this.userSettings.epub.margins ?? MARGINS_DEFAULT;
        },
    },
    methods: {
        ...mapActions(['updateUserSettings']),

        selectOption(option) {
            if (option.value === this.selectedValue) return;
            this.$bus.$emit('margins', option.value);
            this.updateUserSettings({ margins: option.value });
        },
    },
};
</script>
